import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import App from "./App";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import Callback from "./components/Callback";
// import ErrorPage from "./components/ErrorPage";
import { UserManagerProvider } from "./context/UserManagerContext";
import { EnvironmentProvider } from "./context/EnvironmentContext";
import { TypeProvider } from "./context/TypeContext";
import { LanguageProvider } from "./context/LanguageContext";
// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App />,
//     errorElement: <ErrorPage />,
//   },
//   {
//     path: "/callback",
//     element: <Callback />,
//     errorElement: <ErrorPage />,
//   },
//   {
//     path: "/error",
//     element: <ErrorPage />,
//     errorElement: <ErrorPage />,
//   },
// ]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <EnvironmentProvider>
      <TypeProvider>
        <UserManagerProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </UserManagerProvider>
      </TypeProvider>
    </EnvironmentProvider>
  </React.StrictMode>
);
